import { createScopedDescriptor } from 'quartz/globalState/api';

// Similar to RegisterableIntlProvider, but with no options to register.

// Create a silo property to store the I18n provider
export const I18N_PROVIDER = createScopedDescriptor('i18nProvider', 'EXECUTION_CONTEXT');